import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import TextField from '@mui/material/TextField';

const validationSchema = yup.object({
  motivo: yup.string().required('El motivo no puede estar vacío'),
});

function ReabrirTicketModal(props) {
  const { open, close, afterConfirm } = props;
  const { fetch: sendRequest, loading } = useFetch();

  const isRequerimiento = /^R-\d+$/.test(props?.data?.codigo);

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const reabrirTicket = React.useCallback(
    async (data) => {
      await sendRequest(
        `/tickets/${isRequerimiento ? 'requerimientos' : 'incidentes'}/${
          props?.data?.codigo
        }/reabrir`,
        { method: 'POST', data },
      );
    },
    [sendRequest, props.data.codigo, isRequerimiento],
  );

  const formik = useFormik({
    initialValues: { motivo: '' },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      await reabrirTicket(values);
      resetForm();
      close();

      if (afterConfirm && typeof afterConfirm === 'function') {
        afterConfirm();
      }
    },
  });

  return (
    <Modal
      title={`¿Está seguro de reabrir el ${
        isRequerimiento ? 'Requerimiento' : 'Incidente'
      }: ${props?.data.codigo}?`}
      content={
        <TextField
          margin="normal"
          fullWidth
          multiline
          rows={3}
          id="motivo"
          label={`Motivo de Reapertura del ${
            isRequerimiento ? 'Requerimiento' : 'Incidente'
          }`}
          name="motivo"
          autoComplete="motivo"
          value={formik.values.motivo}
          onChange={formik.handleChange}
          disabled={loading}
          error={formik.touched.motivo && Boolean(formik.errors.motivo)}
          helperText={formik.touched.motivo && formik.errors.motivo}
        />
      }
      open={open}
      close={onCloseModal}
      onConfirm={formik.handleSubmit}
      loading={loading}
      disabled={loading}
      confirmButtonText="Guardar"
      cancelButtonText="Cerrar"
    />
  );
}

export default ReabrirTicketModal;
